<template>
  <div>
    <!-- Hero -->
    <base-page-heading :title="comparisonGroup.name">
      <template #extra>
        <b-breadcrumb class="breadcrumb-alt">
          <b-breadcrumb-item>
            <router-link to="/">{{ $t("layout.breadcrumb.home") }}</router-link>
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            {{ $t("layout.breadcrumb.admin") }}
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            <router-link to="/admin/comparison_groups">
              {{ $t("layout.breadcrumb.comparisonGroups") }}
            </router-link>
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            {{ comparisonGroup.shortName }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </template>
    </base-page-heading>
    <!-- END Hero -->

    <!-- Remove Item Block Modal -->
    <b-modal
      id="modal-block-remove-item"
      body-class="p-0"
      hide-footer
      hide-header
    >
      <div class="block block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark">
          <h3 class="block-title">
            {{ $t("admin.comparisonGroupData.modal.remove.title") }}
          </h3>
          <div class="block-options">
            <button
              type="button"
              class="btn-block-option"
              @click="$bvModal.hide('modal-block-remove-item')"
            >
              <i class="fa fa-fw fa-times"></i>
            </button>
          </div>
        </div>
        <div class="block-content font-size-sm">
          <p>
            {{
              $t("admin.comparisonGroupData.modal.remove.text", {
                item: removeItemData.name || removeItemData.itemDefinition
              })
            }}
          </p>
        </div>
        <div class="block-content block-content-full text-right border-top">
          <b-button
            variant="light"
            size="sm"
            @click="$bvModal.hide('modal-block-remove-item')"
          >
            {{ $t("admin.comparisonGroupData.modal.remove.no") }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="removeItem(removeItemData.itemId)"
          >
            <i class="fa fa-check mr-1"></i>
            {{ $t("admin.comparisonGroupData.modal.remove.yes") }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- END Remove Item Block Modal -->

    <b-container class="content content-narrow">
      <b-row>
        <b-col xl="12">
          <base-block :title="$t('admin.comparisonGroupData.masterdata.title')">
            <template #options>
              <router-link
                :to="'/report?group=' + comparisonGroup.comparisonGroupId"
                class="btn-block-option"
              >
                <i class="fa fa-chart-line"></i>
              </router-link>
            </template>
            <b-row>
              <b-col :xl="colNumber">
                <b-form-group
                  label-cols-sm="4"
                  :label="$t('admin.comparisonGroupData.masterdata.mainGroup')"
                  label-for="group-main-group"
                >
                  <b-form-select
                    id="group-main-group"
                    v-model="comparisonGroup.mainGroupId"
                  >
                    <option
                      v-for="(mainGroup, index) in comparisonMainGroups"
                      v-bind:key="index"
                      :value="mainGroup.mainGroupId"
                      >{{ mainGroup.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  :label="$t('admin.comparisonGroupData.masterdata.name.label')"
                  label-for="group-name"
                >
                  <b-form-input
                    id="group-name"
                    type="text"
                    :placeholder="
                      $t(
                        'admin.comparisonGroupData.masterdata.name.placeholder'
                      )
                    "
                    v-model="comparisonGroup.name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  :label="
                    $t('admin.comparisonGroupData.masterdata.shortName.label')
                  "
                  label-for="group-short-name"
                >
                  <b-form-input
                    id="group-short-name"
                    type="text"
                    :placeholder="
                      $t(
                        'admin.comparisonGroupData.masterdata.shortName.placeholder'
                      )
                    "
                    v-model="comparisonGroup.shortName"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  :label="
                    $t('admin.comparisonGroupData.masterdata.refImage.label')
                  "
                  label-for="group-ref-image"
                >
                  <b-form-input
                    id="group-ref-image"
                    type="text"
                    :placeholder="
                      $t(
                        'admin.comparisonGroupData.masterdata.refImage.placeholder'
                      )
                    "
                    v-model="comparisonGroup.refImage"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="4" v-if="comparisonGroup.refImage !== ''">
                <base-block title="">
                  <img :src="comparisonGroup.refImage" class="img-fluid" />
                </base-block>
              </b-col>
            </b-row>
            <div class="form-group form-row" v-if="Auth.isUserManager()">
              <b-col xs="4" class="ml-auto text-left">
                <b-button type="submit" variant="danger" @click="deleteGroup()"
                  >löschen
                </b-button>
              </b-col>
              <b-col xs="8" class="ml-auto text-right">
                <b-button type="submit" variant="primary" @click="updateGroup()"
                  >speichern
                </b-button>
              </b-col>
            </div>
          </base-block>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12">
          <base-block title="Artikel" class="comparison-main-group">
            <b-table-simple
              responsive
              bordered
              striped
              table-class="table-vcenter"
            >
              <b-thead>
                <b-tr>
                  <b-th></b-th>
                  <b-th class="text-center">{{
                    $t("admin.comparisonGroupData.table.competitor")
                  }}</b-th>
                  <b-th>{{ $t("admin.comparisonGroupData.table.name") }}</b-th>
                  <b-th>{{ $t("admin.comparisonGroupData.table.item") }}</b-th>
                  <b-th>{{
                    $t("admin.comparisonGroupData.table.onlyFirstItem.title")
                  }}</b-th>
                  <b-th>{{
                    $t("admin.comparisonGroupData.table.update")
                  }}</b-th>
                  <b-th>{{ $t("admin.comparisonGroupData.table.price") }}</b-th>
                  <b-th></b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="competitor in competitors"
                  v-bind:key="competitor.competitorId"
                  v-bind:value="competitor.competitorId"
                >
                  <b-td>
                    <b-button
                      v-if="
                        comparisonGroupItems[competitor.competitorId] &&
                          Auth.isUserManager()
                      "
                      size="sm"
                      variant="alt-danger"
                      v-b-modal.modal-block-remove-item
                      @click="
                        removeItemData =
                          comparisonGroupItems[competitor.competitorId]
                      "
                    >
                      <i class="fa fa-fw fa-times"></i>
                    </b-button>
                  </b-td>
                  <b-td>
                    {{ competitor.name }}
                  </b-td>
                  <b-td>
                    <span
                      v-if="comparisonGroupItems[competitor.competitorId]"
                      class="text-nowrap"
                    >
                      {{ comparisonGroupItems[competitor.competitorId].name }}
                    </span>
                    <input
                      v-else-if="Auth.isUserManager()"
                      type="text"
                      v-model="newItem.name[competitor.competitorId]"
                      :placeholder="
                        $t('admin.comparisonGroupData.table.placeholder.name')
                      "
                      class="form-control"
                    />
                  </b-td>
                  <b-td>
                    <span v-if="comparisonGroupItems[competitor.competitorId]">
                      {{
                        comparisonGroupItems[competitor.competitorId]
                          .itemDefinition
                      }}
                    </span>
                    <input
                      v-else-if="Auth.isUserManager()"
                      type="text"
                      v-model="newItem.itemDefinition[competitor.competitorId]"
                      :placeholder="
                        $t('admin.comparisonGroupData.table.placeholder.item')
                      "
                      class="form-control"
                    />
                  </b-td>
                  <b-td>
                    <span v-if="comparisonGroupItems[competitor.competitorId]">
                      {{
                        $t(
                          "admin.comparisonGroupData.table.onlyFirstItem." +
                            comparisonGroupItems[competitor.competitorId]
                              .onlyFirstItem
                        )
                      }}
                    </span>
                    <select
                      v-else-if="Auth.isUserManager()"
                      v-model="newItem.onlyFirstItem[competitor.competitorId]"
                      class="form-control text-center"
                    >
                      <option value="no">
                        Alle Artikel
                      </option>
                      <option value="yes">
                        Erster Artikel
                      </option>
                      <option value="second">
                       Zweiter Artikel
                      </option>
                    </select>
                  </b-td>
                  <b-td>
                    <span
                      v-if="comparisonGroupItems[competitor.competitorId]"
                      class="text-nowrap"
                    >
                      {{
                        $d(
                          new Date(
                            comparisonGroupItems[competitor.competitorId].date
                          ),
                          "short"
                        )
                      }}
                    </span>
                  </b-td>
                  <b-td>
                    <span v-if="comparisonGroupItems[competitor.competitorId]">
                      {{
                        $n(
                          comparisonGroupItems[competitor.competitorId].price,
                          "currency"
                        )
                      }}
                    </span>
                  </b-td>
                  <b-td>
                    <router-link
                      :to="
                        '/admin/items/' +
                          comparisonGroupItems[competitor.competitorId].itemId +
                          '/'
                      "
                      v-if="comparisonGroupItems[competitor.competitorId]"
                    >
                      <b-button size="sm" variant="alt-primary">
                        <i class="fa fa-fw fa-angle-right"></i>
                      </b-button>
                    </router-link>
                    <b-button
                      v-else
                      size="sm"
                      variant="alt-primary"
                      @click="addItem(competitor.competitorId)"
                    >
                      <i class="fa fa-fw fa-plus"></i>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </base-block>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12">
          <base-block :title="$t('admin.comparisonGroupData.keywords.title')">
            <ul class="keyword-list">
              <li
                v-for="(keyword, index) in comparisonGroupKeywords"
                v-bind:key="keyword.keywordId"
                :class="{ match: keyword.isKeywordSelected }"
                @click="toogleKeyword(index)"
              >
                {{ keyword.keyword }}
              </li>
            </ul>
          </base-block>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src

import ComparisonMainGroups from "@/assets/js/ComparisonMainGroups";
import Loading from "@/store/loading";
import Items from "@/assets/js/ComparisonGroups/Items";
import Keywords from "@/assets/js/ComparisonGroups/Keywords";
import Competitors from "@/assets/js/Competitors";
import ComparisonGroups from "@/assets/js/ComparisonGroups";
import Notification from "@/assets/js/Notification";
import Auth from "@/assets/js/Auth";

export default {
  name: "comparisonGroupData",
  components: {},
  data() {
    return {
      nullValue: undefined,
      comparisonGroup: {
        name: "",
        mainGroupId: 0
      },
      comparisonGroupItems: [],
      comparisonGroupKeywords: [],
      comparisonMainGroups: [],
      competitors: [],
      newItem: {
        name: [],
        itemDefinition: [],
        onlyFirstItem: []
      },
      removeItemData: {},
      Auth: Auth
    };
  },
  mounted() {
    Notification.init(this);

    Loading.dispatch("increase", 3);
    ComparisonMainGroups.getListWithSubGroups().then(comparisonMainGroups => {
      for (let mainGroupKey in comparisonMainGroups) {
        this.$set(this.comparisonMainGroups, mainGroupKey, {
          mainGroupId: comparisonMainGroups[mainGroupKey].mainGroupId,
          name: comparisonMainGroups[mainGroupKey].name
        });

        for (let groupKey in comparisonMainGroups[mainGroupKey].subGroups) {
          if (
            comparisonMainGroups[mainGroupKey].subGroups[groupKey]
              .comparisonGroupId == this.$route.params.groupId
          ) {
            this.$set(
              this,
              "comparisonGroup",
              comparisonMainGroups[mainGroupKey].subGroups[groupKey]
            );
            this.$set(
              this.comparisonGroup,
              "mainGroupId",
              comparisonMainGroups[mainGroupKey].mainGroupId
            );

            document.title = this.comparisonGroup.name;
            break;
          }
        }
      }

      if (this.comparisonGroup.name == "") {
        this.$router.push("/admin/comparison_groups");
      }

      Loading.dispatch("reduce");
    });

    this.getItems(this.$route.params.groupId);

    Competitors.get().then(competitors => {
      this.$set(this, "competitors", competitors);
      Loading.dispatch("reduce");
    });

    Keywords.get(this.$route.params.groupId).then(result => {
      this.comparisonGroupKeywords = result;
      Loading.dispatch("reduce");
    });
  },
  updated() {},
  methods: {
    addItem: function(competitorId) {
      if (Auth.isUserManager()) {
        console.log(typeof this.newItem.itemDefinition[competitorId]);
        if (
          typeof this.newItem.itemDefinition[competitorId] === "string" &&
          this.newItem.itemDefinition[competitorId] !== ""
        ) {
          Loading.dispatch("increase");

          Items.addByItemDefinition(
            this.$route.params.groupId,
            competitorId,
            this.newItem.name[competitorId],
            this.newItem.itemDefinition[competitorId],
            this.newItem.onlyFirstItem[competitorId]
          ).then(result => {
            if (result) {
              this.getItems(this.$route.params.groupId);
              Notification.push(
                "Successful",
                "Artikel wurde hinzugefügt",
                "success"
              );
            } else {
              Notification.push(
                "Error",
                "Artikel konnte nicht hinzugefügt werden",
                "danger"
              );
            }
            Loading.dispatch("reduce");
          });
        } else {
          Notification.push("Error", "Artikelnummer-Feld ist leer", "danger");
        }
      }
    },
    removeItem: function(itemId) {
      if (Auth.isUserManager()) {
        this.$bvModal.hide("modal-block-remove-item");
        Loading.dispatch("increase");
        Items.removeItem(this.$route.params.groupId, itemId).then(result => {
          if (result) {
            this.getItems(this.$route.params.groupId);
            Notification.push(
              "Successful",
              "Artikel aus Vergleichsgruppe entfernt",
              "success"
            );
          } else {
            Notification.push(
              "Error",
              "Artikel konnte nicht aus Vergleichsgruppe entfernt werden",
              "danger"
            );
          }
          Loading.dispatch("reduce");
        });
      }
    },
    getItems: function(groupId) {
      Loading.dispatch("increase");
      Items.get(groupId).then(items => {
        this.$set(this, "comparisonGroupItems", items);
        Loading.dispatch("reduce");
      });
    },
    updateGroup: function() {
      if (Auth.isUserManager()) {
        Loading.dispatch("increase");
        ComparisonGroups.update(
          this.$route.params.groupId,
          parseInt(this.comparisonGroup.mainGroupId),
          this.comparisonGroup.name,
          this.comparisonGroup.shortName,
          this.comparisonGroup.refImage
        ).then(() => {
          Loading.dispatch("reduce");
        });
      }
    },
    deleteGroup: function() {
      if (Auth.isUserManager()) {
        Loading.dispatch("increase");
        ComparisonGroups.deleteGroup(this.$route.params.groupId).then(
          result => {
            Loading.dispatch("reduce");
            if (result) {
              this.$router.push("/admin/comparison_groups");
            } else {
              Notification.push(
                "Error",
                "Vergleichsgruppe konnte nicht gelöscht werden. Evtl. sind noch Artikel zugeordnet.",
                "danger"
              );
            }
          }
        );
      }
    },
    toogleKeyword: function(keywordIndex) {
      if (Auth.isUserManager()) {
        if (
          this.comparisonGroupKeywords[keywordIndex].isKeywordSelected === true
        ) {
          Keywords.remove(
            this.$route.params.groupId,
            this.comparisonGroupKeywords[keywordIndex].keywordId
          ).then(result => {
            if (result) {
              this.comparisonGroupKeywords[
                keywordIndex
              ].isKeywordSelected = false;
            }
          });
        } else {
          Keywords.add(
            this.$route.params.groupId,
            this.comparisonGroupKeywords[keywordIndex].keywordId
          ).then(result => {
            if (result) {
              this.comparisonGroupKeywords[
                keywordIndex
              ].isKeywordSelected = true;
            }
          });
        }
      }
    }
  },
  computed: {
    colNumber: function() {
      return this.comparisonGroup.refImage !== "" ? 8 : 12;
    }
  }
};
</script>

<style lang="scss">
.keyword-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 1em;
    display: inline-block;
    list-style: none;
    padding: 0.5em 2em 0.5em 2em;
    border-radius: 0.5em;
    margin: 0.5em;
    background-color: #f4f4f4;
    color: #aaaaaa;
    cursor: pointer;
  }

  li.match {
    background-color: #9b8d75;
    color: #ffffff;
  }
}
</style>
